"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importVirtualCategories = void 0;
const routes_1 = require("../../routes");
const importVirtualCategories = (client) => async (params, file, { correlationfileid, filename, fileurl } = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    if ('subTaskId' in params) {
        const url = routes_1.ENDPOINTS.IMPORT_VIRTUAL_CATEGORIES_AUTO.applyParams(params);
        const response = await client.put(url, formData, {
            headers: {
                correlationfileid,
                filename,
                fileurl,
            },
        });
        return response.data;
    }
    else {
        const url = routes_1.ENDPOINTS.IMPORT_VIRTUAL_CATEGORIES.applyParams(params);
        const response = await client.put(url, formData, {
            headers: {
                correlationfileid,
                filename,
                fileurl,
            },
        });
        return response.data;
    }
};
exports.importVirtualCategories = importVirtualCategories;
